import React from "react";
import { useTranslation } from "react-i18next";

import { makeBEM } from "utils";

import "./index.scss";

const bem = makeBEM("auth-layout");

export const AuthLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { i18n } = useTranslation();

  return (
    <div className={bem(null)} dir={i18n.dir()}>
      {children}
      <div className={bem("background")} />
    </div>
  );
};
